import { useTranslation } from "react-i18next";

import { useHasKey } from "../components/useHasKey";

/**
 * What the product actually does, as a list a reader can scan.
 *
 * `calls` and `organize` are absent on purpose: those two get a section of their own with
 * the screen that proves them (see Home.tsx), and a claim stated twice on one page reads as
 * padding. Every remaining features.* key is here, so the dictionary has no orphan entries.
 *
 * Laid out as a hairline grid rather than as cards with gaps between them: six separate
 * floating boxes read as six unrelated things, and this is one list.
 */
const FEATURES = [
  "chats",
  "groups",
  "attachments",
  "miniApps",
  "blocking",
  "devices",
] as const;

export function Features() {
  const { t } = useTranslation();
  const has = useHasKey();

  const features = FEATURES.filter((feature) => has(`features.${feature}.title`));

  if (features.length === 0) return null;

  return (
    <section className="section" id="features">
      <div className="section__head">
        <span className="section__eyebrow">02</span>
        <h2 className="section__heading">{t("features.heading")}</h2>
        {has("features.lede") ? <p className="section__lede">{t("features.lede")}</p> : null}
      </div>

      <ul className="grid grid--2">
        {features.map((feature) => (
          <li className="feature" key={feature}>
            <h3 className="feature__title">{t(`features.${feature}.title`)}</h3>
            <p className="feature__body">{t(`features.${feature}.body`)}</p>
          </li>
        ))}
      </ul>
    </section>
  );
}
